<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <ul class="grid gap-x-5" style="grid-template-columns: 1fr auto">
        <el-form-item
          label="名称"
          prop="name"
          :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            active-text="启用"
            inactive-text="禁用"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
      </ul>
      <ul class="grid gap-x-5" style="grid-template-columns: 20% 1fr">
        <el-form-item
          label="类型"
          prop="type"
          :rules="[{ required: true, message: '请选择类型', trigger: 'blur' }]"
        >
          <el-select v-model="state.model.type" placeholder="--请选择--">
            <el-option
              v-for="item in $base.Meeting_Place_Type"
              :key="item"
              :label="item.Text"
              :value="item.Key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="乙方">
          <el-select
            v-model="state.model.bill_unit_id"
            filterable
            placeholder="--请选择--"
          >
            <template #label="{ value }">
              <div
                v-if="yfdw_map.get(value)"
                class="grid !w-full"
                style="grid-template-columns: 1fr auto"
              >
                <text>{{ yfdw_map.get(value).name }}</text>
                <text class="text-gray-400">{{ yfdw_map.get(value).number }}</text>
              </div>
            </template>
            <el-option
              v-for="item in state.yfdw_data"
              :key="item.id"
              :label="`${item.name} ${item.number}`"
              :value="item.id"
              style="height: auto"
            >
              <div class="grid" style="grid-template-columns: 1fr auto">
                <text>{{ item.name }}</text>
                <text class="text-gray-400">{{ item.number }}</text>
              </div>
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadYfdw()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
      </ul>
      <ul class="grid gap-x-3" style="grid-template-columns: 2.5fr 0.6fr 1fr">
        <el-form-item
          label="场地"
          prop="hotel_id"
          :rules="[
            { required: true, message: '请选择场地', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!state.model.hotel_hall_id)
                  return callback(new Error('请选择会议厅'));
                else callback();
              },
              trigger: 'blur',
            },
          ]"
        >
          <div class="grid gap-x-3 grid-cols-2 w-full">
            <el-select
              v-model="state.model.hotel_id"
              placeholder="选择酒店"
              @change="
                delete state.model.hall_data;
                onLoadHall();
              "
            >
              <el-option
                v-for="item in state.hotel_data"
                :key="item"
                :label="item.name"
                :value="item.id"
                style="height: auto"
              >
                <div class="pb-2">
                  <ul>
                    {{
                      item.name
                    }}
                  </ul>
                  <ul class="text-gray-400 text-xs">
                    {{
                      item.address
                    }}
                  </ul>
                </div>
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadHotel"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
            <el-select
              v-model="state.model.hotel_hall_id"
              placeholder="选择会议厅"
            >
              <el-option
                v-for="item in state.hall_data"
                :key="item"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadHall"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="序号">
          <template #label>
            <div class="flex gap-x-1 items-center">
              <text>序号</text>
              <el-tooltip effect="dark" content="序号越大，显示越靠前">
                <el-icon class="cursor-pointer">
                  <QuestionFilled />
                </el-icon>
              </el-tooltip>
            </div>
          </template>
          <el-input v-model="state.model.sort"></el-input>
        </el-form-item>
        <el-form-item
          label="负责人"
          prop="belonger_id"
          :rules="[
            { required: true, message: '请选择负责人', trigger: 'blur' },
          ]"
        >
          <c_userselect
            v-model="state.model.belonger_id"
            @change:item="
              (item) => {
                state.model.belonger_department_id = item.department_id;
              }
            "
          />
        </el-form-item>
      </ul>

      <el-form-item label="备注">
        <el-input v-model="state.model.intro" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from "vue";
import {
  meeting_place_detail,
  meeting_place_add,
  meeting_place_edit,
} from "@/http/meeting";
import {
  data_getBillUnit,
  data_getHotel,
  data_getHotelHall,
} from "@/http/data";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    meeting_id: Number,
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      state.model.meeting_id = props.meeting_id;
      onLoadYfdw();
      onLoadHotel();
      if (props.id) {
        meeting_place_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data;
            onLoadHall();
          }
        });
      }
    });

    //获取乙方单位
    const onLoadYfdw = () => {
      data_getBillUnit().then((res) => {
        if (res.status == 200) state.yfdw_data = res.data?.data?.list || [];
      });
    };

    //乙方单位 id 索引，O(1) 查找
    const yfdw_map = computed(() => {
      const m = new Map();
      state.yfdw_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    //获取酒店
    const onLoadHotel = () => {
      data_getHotel().then((res) => {
        if (res.status == 200) state.hotel_data = res.data?.data?.list || [];
      });
    };

    //获取宴会厅
    const onLoadHall = () => {
      data_getHotelHall(state.model.hotel_id).then((res) => {
        if (res.status == 200) state.hall_data = res.data?.data?.list || [];
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            meeting_place_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            meeting_place_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      yfdw_map,
      onSubmit,
      onLoadYfdw,
      onLoadHotel,
      onLoadHall,
    };
  },
};
</script>
<style scoped></style>
